<!-- Loader global -->
<div class="loader-wrapper" *ngIf="!ready || done">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</div>

<div class="invoice-settings-page" *ngIf="ready">

  <!-- Header -->
  <div class="container-fluid mb-4">
    <div class="us-page-header">
      <div class="us-page-header__left">
        <div class="us-page-header__icon"><mat-icon>receipt</mat-icon></div>
        <div>
          <h1 class="us-page-header__title">Diseño y configuración de factura</h1>
          <p class="us-page-header__sub">
            Elige la plantilla que mejor encaja con tu negocio y personaliza los textos que aparecerán en tus facturas.
          </p>
        </div>
      </div>

      <div class="us-page-header__actions">
        <button mat-stroked-button class="btn-convfact" (click)="downloadTicket()">
          Descargar Ticket
        </button>

        <button mat-flat-button class="us-btn-save" (click)="save()">
          <mat-icon class="me-1">save</mat-icon>
          Guardar cambios
        </button>
      </div>
    </div>
  </div>

  <!-- Layouts -->
  <div class="container-fluid mb-4">
    <mat-card appearance="outlined" class="settings-card settings-card--layouts">
      <div class="section-header mb-3">
        <div>
          <div class="section-eyebrow">Plantillas disponibles</div>
          <h4 class="section-title mb-1">Selecciona el diseño de tu factura</h4>
          <p class="section-text mb-0">
            Esta plantilla se utilizará al generar las facturas ligadas a esta actividad.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-xl-3 mb-4" *ngFor="let layout of invoiceLayouts; trackBy: trackByIndex">
          <div class="invoice-layout-card" [class.selected]="activity.invoiceLayout === layout.id"
            (click)="activity.invoiceLayout = layout.id">

            <div class="layout-topbar">
              <span class="layout-tag" *ngIf="layout.tag">{{ layout.tag }}</span>
              <span class="layout-selected-pill" *ngIf="activity.invoiceLayout === layout.id">
                <mat-icon>check_circle</mat-icon>
                Seleccionada
              </span>
            </div>

            <div class="invoice-layout-preview">
              <img [src]="layout.preview" [alt]="layout.name" class="img-fluid">
            </div>

            <div class="invoice-layout-content">
              <div class="layout-title-row">
                <div>
                  <h5 class="layout-title mb-1">{{ layout.name }}</h5>
                  <div class="layout-subtitle">{{ layout.subtitle }}</div>
                </div>
              </div>

              <p class="layout-description mb-3">
                {{ layout.description }}
              </p>

              <div class="layout-actions">
                <button type="button" mat-stroked-button class="me-2 preview-btn"
                  [disabled]="previewLoadingLayoutId === layout.id" (click)="previewLayout(layout, $event)">

                  <ng-container *ngIf="previewLoadingLayoutId !== layout.id; else previewLoadingTpl">
                    Vista previa
                  </ng-container>

                  <ng-template #previewLoadingTpl>
                    <span class="d-inline-flex align-items-center">
                      <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
                      <span class="ms-2">Generando...</span>
                    </span>
                  </ng-template>
                </button>

                <button type="button" mat-button class="layout-select-btn"
                  (click)="activity.invoiceLayout = layout.id; $event.stopPropagation()">
                  Usar este diseño
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- Personalización: color de acento y lateral -->
  <div class="container-fluid mb-4">
    <mat-card appearance="outlined" class="settings-card">
      <div class="section-header mb-4">
        <div>
          <div class="section-eyebrow">Personalización</div>
          <h4 class="section-title mb-1">Color y lateral de la factura</h4>
          <p class="section-text mb-0">
            Elige el color de acento de tu factura y, si lo necesitas, añade un texto en el margen izquierdo
            (por ejemplo, datos registrales de tu empresa).
          </p>
        </div>
      </div>

      <form onkeypress="return event.keyCode != 13 || event.target.tagName === 'TEXTAREA';">

        <!-- Color de acento -->
        <div class="form-block mb-4">
          <div class="d-flex align-items-center mb-2">
            <label class="form-block-title mb-0">Color de acento</label>
          </div>

          <div class="color-picker">
            <div class="color-option" *ngFor="let color of accentColorPresets; trackBy: trackByIndex"
              [style.background-color]="color" [class.selected]="activity.invoiceAccentColor === color"
              (click)="selectAccentColor(color)">
            </div>
            <div class="color-option custom-color">
              <input type="color" name="invoiceAccentColor" [(ngModel)]="activity.invoiceAccentColor"
                [ngModelOptions]="{standalone: true}" title="Seleccionar color personalizado">
            </div>
          </div>
          <small class="text-muted">Este color se aplicará a los títulos, cabeceras de tabla y totales de tu factura.</small>
        </div>

        <!-- Texto lateral -->
        <div class="form-block mb-4">
          <div class="d-flex align-items-center mb-2">
            <label class="form-block-title mb-0">Texto lateral</label>
          </div>

          <mat-form-field class="w-100" appearance="outline">
            <textarea matInput rows="2" maxlength="500" name="invoiceSidebarText"
              [(ngModel)]="activity.invoiceSidebarText"
              placeholder="Ej: OBJETIVO 55 CANARIAS, S.L. - Inscrita en el Registro Mercantil...">
            </textarea>
          </mat-form-field>
          <small class="text-muted">Se imprime en vertical en el margen izquierdo del documento. Déjalo vacío si no lo necesitas.</small>
        </div>

        <button type="button" mat-stroked-button class="preview-btn" [disabled]="test" (click)="downloadInvoice()">
          <ng-container *ngIf="!test; else previewCustomLoadingTpl">
            Vista previa con estos cambios
          </ng-container>

          <ng-template #previewCustomLoadingTpl>
            <span class="d-inline-flex align-items-center">
              <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
              <span class="ms-2">Generando...</span>
            </span>
          </ng-template>
        </button>
      </form>
    </mat-card>
  </div>

  <!-- Text settings -->
  <div class="container-fluid">
    <mat-card appearance="outlined" class="settings-card">
      <div class="section-header mb-4">
        <div>
          <div class="section-eyebrow">Contenido</div>
          <h4 class="section-title mb-1">Textos y ajustes legales</h4>
          <p class="section-text mb-0">
            Personaliza el pie de página y el texto de protección de datos que aparecerá en tus documentos.
          </p>
        </div>
      </div>

      <form onkeypress="return event.keyCode != 13 || event.target.tagName === 'TEXTAREA';">

        <!-- Pie de página -->
        <div class="form-block mb-4">
          <div class="d-flex align-items-center mb-2">
            <label class="form-block-title mb-0">Pie de página</label>
            <app-help key="MiEmpresa35" class="ms-2"></app-help>
          </div>

          <mat-form-field class="w-100" appearance="outline">
            <textarea matInput rows="3" name="userCompany.invoiceFooter" [(ngModel)]="userCompany.invoiceFooter"
              placeholder="Escribe aquí tu eslogan, información adicional o cualquier texto corporativo">
            </textarea>
          </mat-form-field>
        </div>

        <!-- Protección de datos -->
        <div class="form-block">
          <div class="d-flex align-items-center mb-2">
            <label class="form-block-title mb-0">Protección de datos</label>
            <app-help key="MiEmpresa36" class="ms-2"></app-help>
          </div>

          <mat-form-field class="w-100" appearance="outline">
            <textarea matInput rows="6" name="userCompany.lopd" [(ngModel)]="userCompany.lopd"
              placeholder="En cumplimiento con la normativa europea de protección de datos RGPD...">
            </textarea>
          </mat-form-field>

          <div class="form-extra">
            <mat-checkbox (change)="onChangesuggestedText($event)" [ngModelOptions]="{standalone: true}"
              [(ngModel)]="suggestedTextLODP">
              Aplicar texto sugerido
            </mat-checkbox>
          </div>
        </div>

      </form>
    </mat-card>
  </div>
</div>